import { createFont } from '@tamagui/core'

// Poppins for display/hero text
export const poppinsFont = createFont({
  family: `'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
  size: {
    1: 12,
    2: 14,
    3: 16,
    4: 18,
    5: 20,
    6: 24,
    7: 32,
    8: 40,
    9: 48,
    10: 56,
    11: 64,
    12: 72,
    13: 80,
  },
  lineHeight: {
    1: 16,
    2: 18,
    3: 22,
    4: 26,
    5: 28,
    6: 32,
    7: 40,
    8: 48,
    9: 56,
    10: 64,
    11: 72,
    12: 80,
    13: 88,
  },
  weight: {
    1: '300',
    2: '400',
    3: '500',
    4: '600',
    5: '700',
    6: '800',
  },
  letterSpacing: {
    1: 0,
    2: -0.5,
    3: -1,
    4: -1.5,
    5: -2,
  },
})

// Inter for body text
export const interFont = createFont({
  family: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
  size: {
    1: 11,
    2: 12,
    3: 13,
    4: 14,
    5: 16,
    6: 18,
    7: 20,
    8: 24,
    9: 28,
    10: 32,
  },
  lineHeight: {
    1: 16,
    2: 18,
    3: 20,
    4: 22,
    5: 26,
    6: 28,
    7: 32,
    8: 36,
    9: 40,
    10: 44,
  },
  weight: {
    1: '300',
    2: '400',
    3: '500',
    4: '600',
    5: '700',
  },
  letterSpacing: {
    1: 0,
    2: 0,
    3: 0,
    4: -0.25,
    5: -0.5,
  },
})

// Inconsolata for code/technical text
export const inconsolataFont = createFont({
  family: `'Inconsolata', 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace`,
  size: {
    1: 11,
    2: 12,
    3: 13,
    4: 14,
    5: 16,
    6: 18,
  },
  lineHeight: {
    1: 18,
    2: 20,
    3: 22,
    4: 24,
    5: 28,
    6: 30,
  },
  weight: {
    1: '400',
    2: '500',
    3: '600',
  },
  letterSpacing: {
    1: 0,
    2: 0,
    3: 0,
  },
})

// Orbitron for decorative/accent text (used sparingly)
export const orbitronFont = createFont({
  family: `'Orbitron', 'Inter', sans-serif`,
  size: {
    1: 10,
    2: 11,
    3: 12,
    4: 14,
    5: 16,
  },
  lineHeight: {
    1: 14,
    2: 16,
    3: 18,
    4: 20,
    5: 24,
  },
  weight: {
    1: '400',
    2: '500',
    3: '600',
    4: '700',
  },
  letterSpacing: {
    1: 0.5,
    2: 1,
    3: 2,
    4: 3,
  },
})

export const fonts = {
  heading: poppinsFont,
  body: interFont,
  mono: inconsolataFont,
  accent: orbitronFont,
}
